import React, {useEffect, useState} from 'react';
import {Button, Text, TextField} from '@cloudaper/react';
import AppHeader from '../AppHeader';

const Step1 = props => {
  const {
    handleSendLink,
    handleUserEmailChange,
    linkSent,
    userEmail,
    validUserEmail,
  } = props;

  useEffect(() => {
    document.title = 'Ověření e-mailu - Začněte s Document Managerem';
  }, []);

  const [errorDisplayed, setErrorDisplayed] = useState(false);

  return (
    <>
      <AppHeader />

      <div className="appWrapper">
        <div className="appConnectorString appConnectorStringStart" />

        <Text className="appConnectorCounter">1</Text>

        <div className="appContent">
          {linkSent === 'never' ? (
            <>
              <Text className="appHeading centeredText">
                Ověřte svůj e-mail
              </Text>

              <br />
              <Text className="centeredText cardBodyText">
                Zadejte prosím svůj pracovní e-mail. Pošleme vám ověřovací
                odkaz, abychom se ujistili,
                <br />
                že jste to skutečně vy.
              </Text>

              <br />
              <TextField
                error={
                  userEmail && !validUserEmail && errorDisplayed
                    ? 'E-mail není ve správném formátu'
                    : undefined
                }
                success={userEmail && validUserEmail}
                helper
                handleEnter={handleSendLink}
                placeholder="Váš pracovní e-mail"
                onBlur={() => setErrorDisplayed(true)}
                onChange={handleUserEmailChange}
                onFocus={() => setErrorDisplayed(false)}
                value={userEmail}
                type="email"
                id="dm-onboarding-step1"
              />
            </>
          ) : (
            <>
              <Text className="appHeading centeredText">
                E-mail byl odeslán
              </Text>

              <br />
              <Text className="centeredText cardBodyText">
                Podívejte se do své schránky a&nbsp;klikněte na ověřovací odkaz.
              </Text>

              {linkSent === 'once' && (
                <div className="routeButtons">
                  <Button kind="primary" onClick={handleSendLink} raised>
                    Poslat ještě jednou
                  </Button>
                </div>
              )}

              {linkSent === 'twice' && (
                <>
                  <br />
                  <Text className="centeredText cardBodyText">
                    Pokud je někde problém, zkuste to prosím později, nebo nás
                    kontaktujte.
                  </Text>
                </>
              )}
            </>
          )}
        </div>

        {linkSent === 'never' && (
          <div className="appConnectorButtonWrapper">
            <Button
              className="appConnectorButton"
              disabled={!validUserEmail}
              kind="primary"
              onClick={handleSendLink}
              raised
            >
              Poslat ověřovací odkaz
            </Button>
          </div>
        )}
      </div>
    </>
  );
};

export default Step1;
